import { UseFormReturn } from "react-hook-form";
import { FormValues } from "./types";
import { NameField } from "./fields/NameField";
import { EmailField } from "./fields/EmailField";
import { DateOfBirthField } from "./fields/DateOfBirthField";
import { PhoneField } from "./fields/PhoneField";
import { AddressField } from "./AddressField";
import { OccupationAndTFNFields } from "./OccupationAndTFNFields";

interface PersonalInfoFieldsProps {
  form: UseFormReturn<FormValues>;
  isEditing: boolean;
}

export function PersonalInfoFields({ form, isEditing }: PersonalInfoFieldsProps) {
  return (
    <div className="grid gap-6">
      <div className="grid gap-6 md:grid-cols-2">
        <NameField form={form} isEditing={isEditing} />
        <EmailField form={form} isEditing={isEditing} />
      </div>
      <div className="grid gap-6 md:grid-cols-2">
        <DateOfBirthField form={form} isEditing={isEditing} />
        <PhoneField form={form} isEditing={isEditing} />
      </div>
      <AddressField form={form} isEditing={isEditing} />
      <OccupationAndTFNFields form={form} isEditing={isEditing} />
    </div>
  );
}